import { render, staticRenderFns } from "./ClientTwo.vue?vue&type=template&id=0c3544a9&"
import script from "./ClientTwo.vue?vue&type=script&lang=js&"
export * from "./ClientTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports